import Relay from 'react-relay';

export default {
  userStatusList: () => Relay.QL`query{ __type(name:"userStatus") }`,
  certificateValidationStatusList: () => Relay.QL`query{ __type(name:"CertificateValidation") }`,
  viewer: (Component) => Relay.QL`query { viewer { ${Component.getFragment('viewer')} } }`,
};


// WEBPACK FOOTER //
// ./src/queries/UsersListQueries.js